<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16.59 16L12 11.6698L7.41 16L6 14.6604L12 9L18 14.6604L16.59 16Z" fill="currentColor" />
  </svg>
</template>
